import { ThunkAction } from "redux-thunk";
import { RootState } from "../store";
import { AnyAction } from "redux";
import IncidentReportsService from "../services/incidentReports";
import {
  setErrorMessage,
  setSuccessMessage,
} from "./actionsCreators/messageActions";
import { DELETE_USER_SUCCESS, INCIDENT_WAS_CREATED } from "../lib/constants";

export const createIncidentReport =
  (request: any): ThunkAction<void, RootState, unknown, AnyAction> =>
  async (dispatch) => {
    try {
      const response = await IncidentReportsService.create(request);

      dispatch(setSuccessMessage(INCIDENT_WAS_CREATED));

      return await Promise.resolve(response);
    } catch (error: any) {
      dispatch(setErrorMessage(error.response.data.title, true));
      return await Promise.reject(error);
    }
  };

export const deleteIncident =
  (id: string): ThunkAction<void, RootState, unknown, AnyAction> =>
  async (dispatch) => {
    try {
      const res = await IncidentReportsService.remove(id);

      dispatch(setSuccessMessage(DELETE_USER_SUCCESS));

      return await Promise.resolve(res);
    } catch (error: any) {
      dispatch(setErrorMessage(error.response.data.title, true));

      return await Promise.reject(error);
    }
  };
